const stringDateRemoveHours = (date) => {
  if (date.includes('T')) {
    return date.split('T')[0];
  }

  return date;
};

export default stringDateRemoveHours;
